export const SUPPORT_CHAT_WELCOME =
  "Hi there! 👋 I'm here to help with Sellyt. Ask a question or choose a topic below.";

export const SUPPORT_CHAT_QUICK_REPLIES = [
  'How do I set up my store?',
  'Billing & subscription help',
  'I need to talk to someone',
] as const;

export const SUPPORT_CHAT_AGENT = {
  name: 'Sellyt Support',
  role: 'Customer support',
  status: 'Online now',
} as const;
